import { Flower2, HeartHandshake, Sparkles, UtensilsCrossed } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

const ICONS = { HeartHandshake, UtensilsCrossed, Sparkles, Flower2 };

const Servizi = () => (
  <section id="servizi" data-testid="servizi-section" className="py-24 sm:py-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading
        chapter="04"
        eyebrow="Servizi"
        title="Cura quotidiana, in ogni dettaglio"
        text="Dall'assistenza alla persona alla cucina di ogni giorno: tutto è pensato per il benessere e la serenità dei nostri ospiti."
        testid="servizi-heading"
        hint="servizi-scroll-hint"
      />
      <div className="mt-8 flex touch-pan-x snap-x snap-mandatory gap-4 overflow-x-auto pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden lg:mt-16 lg:touch-auto lg:grid lg:grid-cols-2 lg:gap-6 lg:overflow-visible lg:pb-0">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.title} delay={i * 0.1} className="w-[88%] shrink-0 snap-start lg:w-auto">
              <div
                data-testid={`service-card-${i}`}
                className="group h-full rounded-[2rem] border border-sand bg-card p-8 transition-all duration-500 hover:border-sage/40 hover:shadow-xl hover:shadow-sage/10 sm:p-10"
              >
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-sage-light text-sage transition-colors duration-500 group-hover:bg-sage group-hover:text-ivory">
                  <Icon size={24} strokeWidth={1.6} />
                </span>
                <h3 className="mt-6 font-serif text-2xl sm:text-3xl font-medium text-ink">{s.title}</h3>
                <ul className="mt-5 space-y-2.5">
                  {s.items.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-moss">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-terracotta/70" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Servizi;
